import script from "./NkText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NkText.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__